module.exports = __webpack_public_path__ + "static/TTNormsPro-BoldItalic-949a2960c750b16d8d030e4a910d33e7.woff2";